import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChange,
} from "@angular/core";
import {LookupsService} from "../../../lookups/services/lookups.service";
import {LookupRequest} from "../../../lookups/request.lookup";
import {LookupResponse} from "../../../lookups/response.lookup";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {ClinicalStatusService} from "../../services/clinical.status.service";
import {Status} from "../../../lookups/lookups.types";
import {LABEL_SUFFIX, TranslateService} from "../../../../common/translate";
import {PatientRecordStatus} from "../../patient.record/models/patient.record.status";
import IStatus = Status.Status;

/**
 * Created by sagil on 06/02/2017.
 */

@UntilDestroy()
@Component({
	selector: 'cp-patient-status',
	templateUrl: './patient.status.template.html',
	styleUrls: ['./patient.status.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientStatusComponent implements OnInit, OnChanges, OnDestroy{
	@Input() statusKey:number;
	@Input() selected:boolean;
	@Input() showLabel:boolean = true;
	@Input() showIcon:boolean = true;

	public iconTable;

	public status: IStatus;
	public patientRecordStatus: PatientRecordStatus;
	public iconRow;

	public PatientRecordStatuses = PatientRecordStatus;

	public statusName;
	public iconClass;

	constructor(private cd:ChangeDetectorRef,
				private lookupsService: LookupsService,
				private clinicalStatusService: ClinicalStatusService,
				private translateService: TranslateService) {
	}

	public ngOnInit() {

		let iconRequest: LookupRequest = this.lookupsService.createRequestGetAllRecords('ICON');
		this.lookupsService.getLookup(iconRequest).pipe(untilDestroyed(this))
			.subscribe((iconRes: LookupResponse<any>) => {
			this.iconTable = iconRes.lookupTable.data;

			this.calcDisplayStatus();
		});
	}

	public ngOnChanges(changes:{[key: string]: SimpleChange}) {
		if (changes['statusKey'] && !changes['statusKey'].isFirstChange()) {
			this.calcDisplayStatus();
		}
	}

	public calcDisplayStatus() {
		this.status = this.clinicalStatusService.getStatusByStatusKey(this.statusKey);
		if (this.status) {
			this.patientRecordStatus = this.clinicalStatusService.getPatientRecordStatusByStatusKey(this.statusKey);
			this.statusName = this.status.name;
			this.iconRow = this.iconTable.find((row) => row['iconKey'] === this.status.iconKey);
			this.iconClass = this.iconRow ? this.iconRow['icon'] : 'cp-icon-help';
		} else {
			this.patientRecordStatus = PatientRecordStatus.Undefined;
			this.statusName = this.translateService.instant('NoCurrentStatus'.concat(LABEL_SUFFIX));
			this.iconClass = 'cp-icon-help';
		}
		this.cd.markForCheck();
	}

	ngOnDestroy(): void {
	}
}
